<template>
  <div>
    <el-upload
      :class="className || 'avatar-uploader'"
      ref="imageUpload"
      name="file"
      :accept="accept"
      :multiple="true"
      :drag="true"
      :action="uploadParams.host"
      :on-change="onChange"
      :data="uploadData"
      :show-file-list="false"
      :on-success="onFileSuccess"
      :on-error="onFileError"
      :on-progress="onProgress"
      :auto-upload="false"
      v-bind="$attrs"
    >
      <slot>
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      </slot>
    </el-upload>
  </div>
</template>

<style lang="scss">
.el-upload-dragger {
  height: 160px !important;
  border: 2px dashed #20a0ff !important;
}
</style>

<script>
import upFile from "../views/picture/assets/scripts/upFile";

export default {
  props: ["uploadedImg", "tip", "className", "currentIndex", "defaultImg"],
  data() {
    return {
      imgSrc: null, // 图片URL
      accept:
        "image/jpeg,image/gif,image/png,image/bmp,image/svg+xml,image/webp,video/*,", // 文件格式
      uploadParams: {
        // 上传参数
        host: "",
      },
    };
  },
  created() {},
  mounted() {
    this.imgSrc = this.uploadedImg;
  },
  computed: {
    uploadData() {
      return {
        policy: this.uploadParams.policy,
        signature: this.uploadParams.signature,
        OSSAccessKeyId: this.uploadParams.oss_accesskey_id,
        success_action_status: "200",
        name: this.filename,
        key: this.filename,
      };
    },
  },
  watch: {
    uploadedImg(val) {
      this.imgSrc = val;
    },
  },

  methods: {
    // 图片选中回调
    async onChange(res) {
      if (res.status === "ready") {
        let imgSrc = await upFile(lib.api, "ec/c/tool/upload/auth/get", res);
        this.$emit("uploaded", imgSrc, res.name);
      }
    },
    // 图片上传成功
    onFileSuccess(res, file, fileList) {},
    // 图片上传失败
    onFileError() {},
    // 图片上传进度
    onProgress(res) {},
  },
};
</script>
